/** Shared nav / shell accents (logo: orange + charcoal) */
export const SELLERCLUB_NAV = {
  activeParentDark: 'bg-slate-800/95 text-white ring-1 ring-inset ring-orange-500/35',
  activeParentLight: 'bg-slate-900 text-white shadow-sm ring-1 ring-orange-500/25',
  inactiveParentDark: 'text-slate-200 hover:bg-slate-800/80 hover:text-white',
  inactiveParentLight: 'text-slate-600 hover:bg-orange-50 hover:text-slate-900',
  activeChildDark: 'bg-slate-800/90 text-orange-400 font-medium border-l-2 border-orange-400',
  activeChildLight: 'bg-orange-50 text-orange-900 font-medium border-l-2 border-orange-500',
  inactiveChildDark:
    'text-slate-300 hover:bg-slate-800/60 hover:text-slate-100 border-l-2 border-transparent',
  inactiveChildLight:
    'text-slate-500 hover:bg-orange-50/60 hover:text-slate-800 border-l-2 border-transparent',
  iconActiveDark: 'text-orange-400',
  iconActiveLight: 'text-orange-500',
  iconInactiveDark: 'text-slate-400 group-hover:text-slate-200',
  iconInactiveLight: 'text-slate-600 group-hover:text-orange-700',
};

/** Detail tabs, links, focus rings */
export const SELLERCLUB_TAB_ACTIVE =
  'border-orange-600 text-orange-800 dark:text-orange-300 dark:border-orange-400 bg-orange-50/90 dark:bg-slate-800/90';

/** Dark shell — warm charcoal + orange accents (not blue/cyan) */
export const SELLERCLUB_DARK = {
  pageBg: 'bg-slate-950',
  panel: 'dark:bg-slate-900/95 dark:border-slate-700/80 dark:ring-1 dark:ring-orange-500/[0.07]',
  inputFocus: 'dark:focus:ring-orange-500/50 dark:focus:border-orange-500/60',
  link: 'dark:text-orange-400 dark:hover:text-orange-300',
  checkbox: 'rgb(249 115 22)',
};
